'use strict';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key]}}}return target};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const io=require('socket.io-client');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const AppReloadRequiredError=require('../../../dist-es6/client/services/errors/appReloadRequiredError');
const SessionExpiredError=require('../../../dist-es6/client/services/errors/sessionExpiredError');
const waitUntil=require('../../../dist-es6/testUtils/waitUntil');
const CustomError=require('pulsar-utils/dist-es6/customError');
const AccessDeniedError=require('../../../dist-es6/client/services/errors/accessDeniedError');
const customParser=require('socket.io-msgpack-parser');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');
const pRetry=require('p-retry');

const CompleteReconnectionThrottleTimeMs=5000;
const isBrowser=typeof window=='object';
const DefaultClientOptions={
path:'/socket.io',
transports:['websocket'],
parser:customParser,
reconnection:isBrowser,
reconnectionDelay:isBrowser?500:0};let


SocketService=function(_BaseService){_inherits(SocketService,_BaseService);
function SocketService($location,$rootScope,cookieRefresherService,Analytics,appVersionService){_classCallCheck(this,SocketService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._$location=$location;
_this._$rootScope=$rootScope;
_this._cookieRefresherService=cookieRefresherService;
cookieRefresherService.socketService=_this;
_this._analytics=Analytics;
_this._appVersionService=appVersionService;

_this._throttledReconnect=_.throttle(function(){return _this.reconnect()},CompleteReconnectionThrottleTimeMs);

_this._socketOptions=DefaultClientOptions;

if("production"==='test'){
_this._socketOptions.ca=require('pulsar-certs/getEnvCa')('test');
}

_this.useMockConnectionStatus=!1;
_this.mockConnectionStatus=!0;

_this._connected=!1;
_this._initiallyConnected=!1;
_this.reconnect();return _this;
}SocketService.prototype.

reconnect=function reconnect(){var _this2=this;
if(_.exists(this._socket)){
this._socket.removeAllListeners();
this._socket.destroy();
delete this._socket;
}

this._resolvesAndRejects={};
this._socket=io.connect(`${this._$location.protocol()}://${this._$location.host()}:${this._$location.port()}`,this._socketOptions);

this._socket.on('error',function(error){
if("production"!=='production'){
console.error(error);
}
_this2._analytics.trackEvent('socket','error',`${error.stack||error.description||error.message||error}`.replace(/[\r\n\t]+/g,' | '));
});

return new Promise(function(resolve,reject){
_this2._socket.on('connect',function(){
_this2._initiallyConnected=!0;
_this2._$rootScope.$evalAsync(function(){
_this2._connected=!0;
resolve();
});
});

_this2._socket.on('disconnect',function(){
resolve(_this2.reconnect());
_this2._$rootScope.$evalAsync(function(){return _this2._connected=!1});
});
});
};SocketService.prototype.







_getResolvesAndRejectsFor=function _getResolvesAndRejectsFor(messageName,throwOnUnexpectedError){var _this3=this;
if(!_.exists(this._resolvesAndRejects[messageName])){
let messageSpecificResolvesAndRejects={};
this._socket.on(`${messageName} - response`,function(responsePacket){
if(!_.exists(messageSpecificResolvesAndRejects[responsePacket.id])){
throw new Error(`no resolve/reject found for ${messageName}: ${responsePacket.id}`);
}

let{resolve:resolve,reject:reject,startTime:startTime,isTimedOut:isTimedOut,timeoutId:timeoutId}=messageSpecificResolvesAndRejects[responsePacket.id];

delete messageSpecificResolvesAndRejects[responsePacket.id];

if(isTimedOut===!0){
return;
}

if(_.exists(timeoutId)){
clearTimeout(timeoutId);
}

switch(responsePacket.data.status){
case'AppReloadRequired':
reject(new AppReloadRequiredError);
break;
case'NotLoggedIn':
reject(new SessionExpiredError);
break;
case'AccessDenied':
reject(new AccessDeniedError);
break;
case'UnexpectedError':
case'InternalError':
if(throwOnUnexpectedError){
reject(new UnexpectedError);
}else{
resolve(responsePacket.data);
}
break;
default:
_this3._analytics.trackTimings('socket',messageName,Date.now()-startTime);
resolve(responsePacket.data);
break;}

});

this._resolvesAndRejects[messageName]=messageSpecificResolvesAndRejects;
}

return this._resolvesAndRejects[messageName];
};SocketService.prototype.

sendAndWaitForResponse=function(){var ref=_asyncToGenerator(function*(messageName){var _this4=this;let requestData=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};let options=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{};
const{timeoutInSeconds=void 0,retryOptions=void 0,throwOnUnexpectedError=!1,keepSessionAlive=!0}=options;

_.ensureInstanceOf('string',messageName);
_.ensureInstanceOf(['number','nullable'],timeoutInSeconds);
_.ensureInstanceOf(['object','nullable'],retryOptions);
_.ensureInstanceOf('boolean',throwOnUnexpectedError);
if(retryOptions){
return yield this._retriedSendAndWaitForResponse(messageName,requestData,options);
}
yield waitUntil(function(){
if(!_this4._initiallyConnected){
return!0;
}

const isConnected=_.exists(_this4._socket)&&_this4._socket.connected===!0;

if(isConnected){
return!0;
}

_this4._throttledReconnect();
return isConnected;
},100);

const messageSpecificResolvesAndRejects=this._getResolvesAndRejectsFor(messageName,throwOnUnexpectedError);

const request={
id:Guid.create().toString(),
data:requestData,
keepSessionAlive:keepSessionAlive,
appRevision:this._appVersionService.getRevision()};


return yield new Promise(function(resolve,reject){
messageSpecificResolvesAndRejects[request.id]={resolve:resolve,reject:reject,startTime:Date.now()};

if(_.exists(timeoutInSeconds)){
messageSpecificResolvesAndRejects[request.id].timeoutId=setTimeout(function(){
if(_.exists(messageSpecificResolvesAndRejects[request.id])){
reject(new SocketTimeoutError);
messageSpecificResolvesAndRejects[request.id].isTimedOut=!0;
}
},timeoutInSeconds*1000);
}

_this4._socket.emit(`${messageName} - request`,request);
if(keepSessionAlive){
_this4._cookieRefresherService.refreshCookie();
}
_this4._analytics.trackEvent('socket','emit',messageName);
});
});function sendAndWaitForResponse(messageName){let requestData=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};let options=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{};return ref.apply(this,arguments)}return sendAndWaitForResponse}();SocketService.prototype.

_retriedSendAndWaitForResponse=function(){var ref=_asyncToGenerator(function*(messageName,requestData,options){var _this5=this;
_.ensureInstanceOf('string',messageName);
const{retryOptions:retryOptions,throwOnUnexpectedError:throwOnUnexpectedError}=options;
let attempt=0;
try{
return yield pRetry(_asyncToGenerator(function*(){
try{
attempt++;
return yield _this5.sendAndWaitForResponse(messageName,_extends({attempt:attempt},requestData),_extends({
throwOnUnexpectedError:!0},
_.omit(options,['retryOptions','throwOnUnexpectedError'])));

}catch(e){
if(e instanceof SocketTimeoutError||e instanceof UnexpectedError){
throw e;
}else{
throw new pRetry.AbortError(e);
}
}
}),
retryOptions);
}catch(e){
if(e instanceof UnexpectedError){
if(throwOnUnexpectedError){
throw e;
}
return new SocketResponse('UnexpectedError');
}
throw e;
}
});function _retriedSendAndWaitForResponse(messageName,requestData,options){return ref.apply(this,arguments)}return _retriedSendAndWaitForResponse}();SocketService.prototype.

dispose=function dispose(){var _this6=this;
return new Promise(function(resolve){
_this6._socket.on('disconnect',function(){
_this6._socket.removeAllListeners();
resolve();
});
_this6._socket.disconnect();
});
};_createClass(SocketService,[{key:'isConnected',get:function(){return this.useMockConnectionStatus?this.mockConnectionStatus:_.get(this._socket,'connected',this._connected)}}]);return SocketService}(BaseService);let


SocketTimeoutError=function(_CustomError){_inherits(SocketTimeoutError,_CustomError);
function SocketTimeoutError(){_classCallCheck(this,SocketTimeoutError);return _possibleConstructorReturn(this,
_CustomError.call(this,'SocketTimeoutError'));
}return SocketTimeoutError}(CustomError);let


UnexpectedError=function(_CustomError2){_inherits(UnexpectedError,_CustomError2);
function UnexpectedError(){_classCallCheck(this,UnexpectedError);return _possibleConstructorReturn(this,
_CustomError2.call(this,'UnexpectedError'));
}return UnexpectedError}(CustomError);


module.exports=SocketService;
module.exports.SocketTimeoutError=SocketTimeoutError;
module.exports.UnexpectedError=UnexpectedError;
//# sourceMappingURL=socketService.js.map
